export const AUTH_TOKEN = 'auth.token'
export const MAKE_ID = 'auth.make'

// Mirrors NoDataAvailable.code in the backend's constants/error_codes.py. An
// export that matched no rows answers 404 with this code, which is how a
// "nothing to export" is told apart from a download that actually failed - a
// network failure carries no status and no code at all.
export const NO_DATA_AVAILABLE = 'NO_DATA_AVAILABLE'

// Mirrors InvalidVisualAidFile.code in the backend's constants/error_codes.py.
// A visual aid save whose SVG is not a visual aid drawing answers 400 with this
// code, so "wrong kind of SVG" can be told apart from a save that failed.
export const INVALID_VISUAL_AID_FILE = 'INVALID_VISUAL_AID_FILE'
